var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvarageHeartRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Average heart rate"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 16H7L12 5L20 26L25 16H29",
    stroke: "#444F60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 185",
    cx: 25.5,
    cy: 25.5,
    r: 4.5,
    stroke: "#444F60",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23 25.5H24.6562L25.125 24.4688L25.875 26.4375L26.3438 25.5H28",
    stroke: "#444F60",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvarageHeartRate);
export default __webpack_public_path__ + "static/media/AvarageHeartRate.a2998d0bac0401a173f9c4148a87cab6.svg";
export { ForwardRef as ReactComponent };